export enum UserDisplayType {
  CustomerService = 'customerService',
  CustomerJobs = 'customerJobs',
  CustomerJobUp = 'customerJobup',
  CustomerJobcloud = 'customerJobcloud',
  CustomerJobScout24 = 'customerJobscout24',
}

const userDisplayTypeValues = new Set(Object.values(UserDisplayType));

export const isUserDisplayType = (value: string): value is UserDisplayType =>
  userDisplayTypeValues.has(value as UserDisplayType);

export const castToUserDisplayType = (value: string): UserDisplayType | null =>
  isUserDisplayType(value) ? value : null;
